import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Skeleton from '../components/Skeleton';
import { RowView, resolveRows, applySeo } from './HomePage';

export default function PageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [vw, setVw] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1280);

  useEffect(() => {
    const f = () => setVw(window.innerWidth);
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);

  useEffect(() => {
    setLoading(true);
    setError(null);
    (async () => {
      try {
        const [p, h] = await Promise.all([
          axios.get(`/pages/${slug}`),
          axios.get('/home').catch(() => ({ data: {} })),
        ]);
        setPage(p.data);
        setData(h.data || {});
        applySeo(p.data.seo || {}, p.data.title);
        setLoading(false);
      } catch (err) {
        setError(err.response?.status === 404 ? 'این برگه یافت نشد.' : 'خطا در بارگذاری برگه');
        setLoading(false);
      }
    })();
  }, [slug]);

  if (loading) {
    return (
      <div className="container" style={{ paddingTop: 'var(--space-4)' }}>
        <Skeleton height="60px" width="40%" />
        <div style={{ marginTop: 20 }}><Skeleton height="300px" /></div>
      </div>
    );
  }
  if (error || !page) {
    return (
      <div style={{ padding: '100px 20px', textAlign: 'center' }}>
        <div style={{ color: '#991B1B', marginBottom: 16 }}>{error || 'خطا'}</div>
        <Link to="/" style={{ color: 'var(--accent)' }}>بازگشت به صفحه اصلی</Link>
      </div>
    );
  }

  const enabled = resolveRows(page.platforms, vw).filter(s => s.enabled !== false);

  return (
    <div>
      {enabled.map((s, i) => {
        if (s.columns) return <RowView key={s.id || i} row={s} data={data} />;
        return null;
      })}
      {enabled.length === 0 && (
        <div className="container" style={{ padding: '80px 20px', textAlign: 'center', color: '#A1A1AA' }}>
          این برگه هنوز محتوایی ندارد.
        </div>
      )}
    </div>
  );
}
